<template>
  <div class="notifications vue-notification-group sm_bar" >
    <div class="sm_bar_inner" v-if="smHandles && smHandles.length && isDashboard">
      <span :aria-label="handle.title" v-for="handle in smHandles" :key="handle.title" :title="handle.title" v-b-tooltip.hover>
        <img :src="handle.icon" @click="take(handle)"></img>
      </span>
    </div>
  </div>
</template>
<script>
import vuex from '../../vuex'
import { mapActions, mapState } from 'vuex'
import _ from 'lodash'

export default {
  name: 'smhandle',
  components: {
  },
  data: () => {
    return {
    smHandles : [],
    isDashboard: false
    }
  },
  async mounted () {
  	   this.smHandles = await this.loadHandles()
  },
    watch: {
      '$route' (to, from) {
          if(!this.smHandles || this.smHandles.length==0){
            this.loadHandles().then(res => {
              this.smHandles.push(...res)
            })
          }
          if(window.location.href.indexOf('/vue/#/dashboard')!=-1 || window.location.href.indexOf('/vue/#/advisor/tracker')!=-1 ){
            this.isDashboard = true
          }else{
            this.isDashboard = false
          }
      }
    },

  methods: {
    ...mapActions([
      'loadHandles'
    ]),
    take (hanlde){
      window.open(hanlde.url, '_blank')
    }
	}
}
</script>



// WEBPACK FOOTER //
// src/app/navigation/components/Smhandle.vue